import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppShell } from "./app/AppShell";
import { CatalogProvider } from "./app/CatalogContext";
import { ROUTES } from "./app/routes";
import { ThemeProvider } from "./app/ThemeProvider";
import { I18nProvider } from "./i18n/I18nProvider";
import { CatalogPage } from "./pages/CatalogPage";
import { EndpointsPage } from "./pages/EndpointsPage";
import { FramesPage } from "./pages/FramesPage";
import { HomePage } from "./pages/HomePage";
import { McpPage } from "./pages/McpPage";
import { ModelPage } from "./pages/ModelPage";
import { OverviewPage } from "./pages/OverviewPage";
import { SkillPage } from "./pages/SkillPage";
import { SkillsPage } from "./pages/SkillsPage";
import { TasksPage } from "./pages/TasksPage";
import { WorkspacesPage } from "./pages/WorkspacesPage";
import { ToastProvider } from "./ui-kit";

export function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <ToastProvider>
          <BrowserRouter>
            <CatalogProvider>
              <AppShell>
                <Routes>
                  <Route path={ROUTES.home} element={<HomePage />} />
                  <Route path={ROUTES.overview} element={<OverviewPage />} />
                  <Route path={ROUTES.catalog} element={<CatalogPage />} />
                  <Route path={ROUTES.model} element={<ModelPage />} />
                  <Route path={ROUTES.mcp} element={<McpPage />} />
                  <Route path={ROUTES.skills} element={<SkillsPage />} />
                  <Route path={ROUTES.skill} element={<SkillPage />} />
                  <Route path={ROUTES.tasks} element={<TasksPage />} />
                  <Route path={ROUTES.frames} element={<FramesPage />} />
                  <Route path={ROUTES.workspaces} element={<WorkspacesPage />} />
                  <Route path={ROUTES.endpoints} element={<EndpointsPage />} />
                  <Route path="*" element={<HomePage />} />
                </Routes>
              </AppShell>
            </CatalogProvider>
          </BrowserRouter>
        </ToastProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}
